import Table from "./../Table";
import TableAdmin from "./TableAdmin";

export default function PillsAdmin({applications, infos, options, subscriptins}){
    return(
        <div>
            <h6 className="text-muted">Options Supplementaires</h6>
            <div className="nav-align-top mb-4">
                <ul className="nav nav-pills mb-3 nav-fill" role="tablist">
                    <li className="nav-item">
                        <button
                            type="button"
                            className="nav-link active"
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target="#navs-pills-justified-home"
                            aria-controls="navs-pills-justified-home"
                            aria-selected="true"
                        >
                            <i className="tf-icons bx bx-receipt"></i> Applications
                        </button>
                    </li>
                    {/*<li className="nav-item">*/}
                    {/*    <button*/}
                    {/*        type="button"*/}
                    {/*        className="nav-link"*/}
                    {/*        role="tab"*/}
                    {/*        data-bs-toggle="tab"*/}
                    {/*        data-bs-target="#navs-pills-justified-profile"*/}
                    {/*        aria-controls="navs-pills-justified-profile"*/}
                    {/*        aria-selected="false"*/}
                    {/*    >*/}
                    {/*        <i className="tf-icons bx bx-id-card"></i> Informations d'abonnements*/}
                    {/*    </button>*/}
                    {/*</li>*/}
                    {/*<li className="nav-item">*/}
                    {/*    <button*/}
                    {/*        type="button"*/}
                    {/*        className="nav-link"*/}
                    {/*        role="tab"*/}
                    {/*        data-bs-toggle="tab"*/}
                    {/*        data-bs-target="#navs-pills-justified-messages"*/}
                    {/*        aria-controls="navs-pills-justified-messages"*/}
                    {/*        aria-selected="false"*/}
                    {/*    >*/}
                    {/*        <i className="tf-icons bx bx-grid"></i>Options d'abonnements*/}
                    {/*    </button>*/}
                    {/*</li>*/}
                    {/*<li className="nav-item">*/}
                    {/*    <button*/}
                    {/*        type="button"*/}
                    {/*        className="nav-link"*/}
                    {/*        role="tab"*/}
                    {/*        data-bs-toggle="tab"*/}
                    {/*        data-bs-target="#navs-pills-justified-statistics"*/}
                    {/*        aria-controls="navs-pills-justified-statistics"*/}
                    {/*        aria-selected="false"*/}
                    {/*    >*/}
                    {/*        <i className="tf-icons bx bx-purchase-tag-alt"></i>Listes des souscriptions*/}
                    {/*    </button>*/}
                    {/*</li>*/}
                </ul>
                <div className="tab-content">
                    <div className="tab-pane fade show active" id="navs-pills-justified-home" role="tabpanel">
                        <TableAdmin title={"Liste applications"} content={applications} type={"app"}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-profile" role="tabpanel">
                        <Table title={"Informations d'abonnements"} content={infos} type={"subscription"}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-messages" role="tabpanel">
                        <Table title={"Informations d'abonnements"} content={options} type={"app"}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-statistics" role="tabpanel">
                        <Table title={"Liste Des Souscriptions"} content={subscriptins} type={"app"}/>
                    </div>
                </div>
            </div>
        </div>
    );
}